import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';

export const useCapacitor = () => {

    /**
     * Metodo que abre los settings de la app tanto para android como para ios
     */
    const openAppSettings = async () => {
        try {
            await NativeSettings.open({
                optionAndroid: AndroidSettings.ApplicationDetails,
                optionIOS: IOSSettings.App,
            });
        } catch (error) {
            console.error('Error al verificar permisos de notificaciones:', error);
        }
    };

    return { openAppSettings };
};